import { Col, Row }                  from "elemental-react16"
import { Button, Card, Icon, Image } from "semantic-ui-react"
import { Link }                      from "react-router-dom"
import { observer }                  from "mobx-react"
import React, { Component }          from "react"
import shop                          from "shop/shop"
import _                             from "lodash"
import "moment/locale/de"

import AccountReset from "components/Account/AccountReset"
import { Redirect } from "react-router"
import OrderTable   from "components/OrderTable/OrderTableAccount";
import OrderModel   from "shop/OrderModel";
import CostCentres  from "components/CostCentres/CostCentres";

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
export default class AccountPage extends Component {

  state = {
    session: shop.session || {}, locations: [], showAddressBook: false, noMoreOrders: false, orderOpen: [], maxOrders: 5, maxOpenOrders: 5
  }

  showMoreOrders = () => {
    this.setState( { maxOrders: this.state.maxOrders + 15 } )
    if ( (this.state.maxOrders + 15) > 80 ) {
      this.loadMore()
    }
  }

  showMoreOpenOrders = () => {
    this.setState( { maxOpenOrders: this.state.maxOpenOrders + 15 } )
    if ( (this.state.maxOpenOrders + 15) > 80 ) {
      this.loadMore()
    }
  }

  loadMore = () => {
    let pageSize = 80
    let start = current
    current = current + pageSize
    this.setState( { loading: true } )
    shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
        .then( res => {
          console.log( "FROM API", { res } )
          orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
          openPositions = []
          // find orders with Open Positions
          let orderOpen = orders.filter( order => {
            return order.positions.filter( product => {
              let hasOpen = product.open && product.open !== 0
              if ( hasOpen ) {
                openPositions.push( product )
              }
              return hasOpen
            } ).length
          } )

          this.setState( { orderOpen, loading: false } )
          if ( res.values.length === 0 ) {
            this.setState( { noMoreOrders: true } )
          }
        } )
  }

  loadSession = ( session ) => {
    this.setState( { noMoreOrders: false } )
    this.loadMore()
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
        .then( locations => {
          this.setState( { locations } )
        } )
  }

  componentDidMount() {
    orders = []
    ordersWithOpenPositions = []
    openPositions = []
    current = 0
    shop.events.authentified.add( this.loadSession )
    // this.loadSession()
  }

  componentWillUnmount() {
    shop.events.authentified.remove( this.loadSession )
  }

  render() {
    let { locations, orderOpen, loading, noMoreOrders } = this.state
    let billingAddress = shop.session.value
    let shortlist = locations.slice( 0, 100 )

    if ( !shop.session ) return <Redirect to={"/"}/>
    if ( !shop.session.value ) return <Redirect to={"/"}/>
    if ( !shop.session.value.extras ) return <Redirect to={"/"}/>

    const note = shop.config.showNote && shop.session.value.extras[ "ts-note" ]

    let locationsOnDisplay = _.map( shortlist, ( location, key ) => {
      return (<Card key={key}
                    sm="1/5">
        <Card.Header>
          <div className="pa3 b black-60">{translate( "Lieferaddresse" )}</div>
        </Card.Header>
        <Card.Content>
          <Address location={location}/>
        </Card.Content>
      </Card>)
    } )

    return (<div className="container pt4">
      <h1 className="page-title"><i className="icon-vcard icon-lg"/><strong>{translate( "My Account" )}</strong></h1>
      <p>{translate( "View your customer data and recent orders" )}</p>
      <section className="pt3">

        {note && <React.Fragment>
          <div className="row-title tl">
            <h2>{translate( "Kundendaten" )}</h2>
          </div>
          <div className={"pre-line pb4"}>{note}</div>
        </React.Fragment>}

        <div className="row-title tl">
          <h2>{translate( "Adressen" )}</h2>
        </div>

        <div className="pt3 pb3">
          <p>{translate( "accountpage.notice_temp_delivery_address" )}.</p>
        </div>
        <div className="ph2">
          <Card.Group itemsPerRow={4} doubling stackable>
            <Card md="1/5" className="">
              <Card.Header>
                <div className="pa3 b black-60">{translate( "Rechnungsadresse" )}</div>
              </Card.Header>
              <Card.Content>
                <div className="">
                  <strong> {billingAddress.title}</strong> <br/>
                  {billingAddress.subtitle && <div>{billingAddress.subtitle}</div>}
                  {billingAddress.street} <br/>
                  {billingAddress.pcode} {billingAddress.city}<br/>
                  {billingAddress.country}<br/>
                </div>
              </Card.Content>
            </Card>
            {locationsOnDisplay}
          </Card.Group>
        </div>
        {/*<Button onClick={()=>{ this.setState({showAddressBook:true})}}>Adressbuch ({locations.length}) öffnen  </Button>*/}
        {/*{showAddressBook && <AddressBook onClose={() => {this.setState( { showAddressBook: false } )}}/>}*/}
      </section>

      <section className="pt4">
        <div className="row-title title--left">
          <h2 className="title">{translate( "Budget" )}</h2>
        </div>
        <CostCentres/>
      </section>
      {/*<section>*/}
      {/*<div className="row-title tl">*/}
      {/*<h2>Mein Benutzer</h2>*/}
      {/*</div>*/}
      {/*</section>*/}

      {/*<section>*/}
      {/*<div className="row-title tl">*/}
      {/*<h2>Adressbuch</h2>*/}
      {/*</div>*/}
      {/*<Button onClick={() => { this.setState( { showAddressBook: true } )}}> Adressbuch öffnen </Button>*/}
      {/*{showAddressBook && <AddressBook onClose={() => {this.setState( { showAddressBook: false } )}}/>}*/}
      {/*</section>*/}


      {/*{shop.session.hasRole("costManager") && <section className="mt4">*/}
      {/*  <div className="row-title title--left">*/}
      {/*    <h2 className="title">{translate( "Budget" )}</h2>*/}
      {/*  </div>*/}
      {/*  */}
      {/*  <div>*/}
      {/*    <Button as={Link} to={"/account/budgets/"}>Open BudgetManager</Button>*/}
      {/*  </div>*/}

      {/*</section>}*/}

      {shop.session.hasRole( "userManager" ) && <section className="pt4">

        <div className="row-title title--left">
          <h2 className="title">{translate( "Benutzer" )}</h2>
        </div>

        <div>
          <Button basic as={Link} to={`/login/accounts/${shop.session.value.map_id}`}>{translate( "bearbeiten" )}</Button>
        </div>

      </section>}


      <section className="pt4">

        <div className="row-title title--left">
          <h2 className="title">{translate( "your field service contact" )}</h2>
        </div>

        {shop.session.value.extras && shop.session.value.extras.verName && <div className={"pb2"}>
          <div className={"pa3 box-shadow ba bg-white mh-auto center ml0-ns "} style={{ maxWidth: "100%", width: "390px" }}>
            <div>
              <div className="flex flex-row-ns flex-column items-center">
                <div className="pr3-ns pb0-ns pb3 tc">
                  <Image
                    title={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    alt={`${shop.session.value.extras.verName}– Ihr Ansprechpartner im Aussendienst`}
                    className={"shadow-inset"}
                    width={210}
                    circular
                    src={`/image/${shop.session.value.extras.verName}.jpg`}/>
                </div>
                <div>
                  <div className={"b black"}>{shop.session.value.extras.verName}</div>
                  <div className={"pb2 nowrap f6 black-80"}> {shop.session.value.extras.verFunktion}</div>
                  {shop.session.value.extras.verPhone &&
                    <div className={""}><a href={`tel:${shop.session.value.extras.verPhone}`}>{shop.session.value.extras.verPhone}</a></div>}
                  {shop.session.value.extras.verMail && <div className={""}><a
                    href={`mailto:${shop.session.value.extras.verMail}?subject=Kundenanfrage Ortho Walker, Kunde #${shop.session.value.map_id}`}>{shop.session.value.extras.verMail}</a>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>}
        {shop.session.value.extras.verMail && <Button className={"db w-100 w-auto-ns"} basic as={"a"}
                                                      href={`mailto:${shop.session.value.extras.verMail}?subject=Kundenanfrage Ortho Walker, Kunde #${shop.session.value.map_id}`}><Icon
          name={"mail"}/> <span>{shop.session.value.extras.verMail}</span></Button>}
        {shop.session.value.extras.verPhone && <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`tel:${shop.session.value.extras.verPhone}`}><span><Icon
          name={"phone"}/> {shop.session.value.extras.verPhone}</span></Button>}
        {!process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={Link} to={"/form/customer_contact"}>{translate( "Kontaktformular" )}</Button>}
        {process.env.REACT_APP_SERVICE_EMAIL &&
          <Button className={"db w-100 w-auto-ns"} basic as={"a"} href={`mailto:${process.env.REACT_APP_SERVICE_EMAIL}`}>{translate( "Kontakt" )}</Button>}
      </section>

      <section className="mt4">
        <div className="row-title title--left">
          <h2 className="title">{translate( "change Password" )}</h2>
        </div>
        <AccountReset email={shop.session.value.email}/>
      </section>

      <section className="mt4 pb5">
        <Row>
          <Col sm="1">
            <div className="row-title title--left">
              <h2 className="title">{translate( "Order History" )}</h2>
            </div>
            {orders.length >= 0 && <OrderTable orders={orders.slice( 0, this.state.maxOrders )}/>}
            {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
            {noMoreOrders && <div className={"f5 black-60"}>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
            {!noMoreOrders && <div className="pa2 tc">
              <Button onClick={this.showMoreOrders} loading={loading}>{translate( "mehr" )}</Button>
            </div>}
          </Col>
        </Row>
      </section>

      {shop.config.plugin.SHOW_BACKORDER && <section className={"pb5-ns pb4"}>
        <div className="row-title title--left">
          <h2 className="title">{translate( "Rückstände" )}</h2>
        </div>
        {orderOpen.length >= 0 && <OrderTable path={"/account/orders/backorder"} orders={orderOpen.slice( 0, this.state.maxOpenOrders )}/>}
        {!orderOpen.length && <p className="black-60">{translate( "No Orders" )}</p>}
        {noMoreOrders && <div className={"f5 black-60"}>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
        {!noMoreOrders && <div className="pa2 tc">
          <Button onClick={this.showMoreOpenOrders} loading={loading}>{translate( "mehr" )}</Button>
        </div>}
      </section>}
      {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
      {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
    </div>)
  }
}


const Address = ( { title, location } ) => {
  const isDeliveryAddress = location.mapid === (shop.cart.deliveraddress && shop.cart.deliveraddress.mapid)
  return (<React.Fragment>
    <div className="address-block ">
      <div>{location.name1}</div>
      <div>{location.name2}</div>
      <div>{location.street}</div>
      <div>{location.pcode} {location.city}</div>
      <div>{location.country}</div>
      <div className="pt3">
        {location.extras && <div>
          {location.extras.ShipmentMethodCode && <div>
            <div className="f7 black-70">{translate( "Lieferbedingungen" )}</div>
            <div className={"f6"}>{location.extras.ShipmentMethodCodeText}</div>
          </div>}
        </div>}
        {/*<a onClick={() => {shop.cart.setAddress( { location } )}} className="black-40" href="#">als Lieferadresse</a> <br/>*/}
        {/*<a className="black-40" href="#">Änderung beantragen</a> <br/>*/}
        {/*<a className="black-40" href="#">löschen</a> <br/>*/}
      </div>
    </div>
  </React.Fragment>)
}



// WEBPACK FOOTER //
// ./src/pages/AccountPage.js